var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgSearch = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "m49.208 54.51 9.591 9.548 4.974-6.872-8.526-8.68-6.04 6.004Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M34.288 54.293c10.594 0 19.183-8.744 19.183-19.53 0-10.786-8.589-19.53-19.183-19.53-10.595 0-19.183 8.744-19.183 19.53 0 10.786 8.588 19.53 19.183 19.53Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "M59.154 34.763c0 13.982-11.133 25.317-24.866 25.317-13.734 0-24.867-11.335-24.867-25.317S20.554 9.447 34.288 9.447c13.733 0 24.867 11.334 24.867 25.316Zm-5.683 0c0 10.786-8.589 19.53-19.183 19.53-10.595 0-19.183-8.744-19.183-19.53 0-10.786 8.588-19.53 19.183-19.53 10.594 0 19.183 8.744 19.183 19.53Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: borderColor,
    d: "M34.288 60.83c14.16 0 25.617-11.683 25.617-26.067h-1.5c0 13.58-10.81 24.567-24.117 24.567v1.5ZM8.67 34.763c0 14.384 11.456 26.067 25.617 26.067v-1.5c-13.307 0-24.117-10.986-24.117-24.567h-1.5ZM34.288 8.697C20.128 8.697 8.67 20.38 8.67 34.763h1.5c0-13.58 10.81-24.566 24.117-24.566v-1.5Zm25.617 26.066c0-14.383-11.457-26.066-25.617-26.066v1.5c13.306 0 24.117 10.986 24.117 24.566h1.5Zm-25.617 20.28c11.021 0 19.933-9.092 19.933-20.28h-1.5c0 10.385-8.266 18.78-18.433 18.78v1.5Zm-19.933-20.28c0 11.188 8.911 20.28 19.933 20.28v-1.5c-10.168 0-18.433-8.395-18.433-18.78h-1.5Zm19.933-20.28c-11.022 0-19.933 9.093-19.933 20.28h1.5c0-10.384 8.265-18.78 18.433-18.78v-1.5Zm19.933 20.28c0-11.187-8.912-20.28-19.933-20.28v1.5c10.167 0 18.433 8.396 18.433 18.78h1.5Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m55.815 49.085 8.029 8.174M57.805 63.407l-8.029-8.174"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M84.945 84.89a5.632 5.632 0 0 1-8.028 0L62.849 70.423l8.028-8.173 14.068 14.466c2.202 2.243 2.202 5.932 0 8.174Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m56.81 64.42 5.897 6.148 8.029-8.174-5.898-6.148-8.028 8.174Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M84.945 84.89a5.632 5.632 0 0 1-8.028 0L56.81 64.42l8.028-8.174 20.107 20.47c2.203 2.243 2.203 5.931 0 8.174ZM62.849 70.568l8.028-8.174"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M21.002 34.763c0-7.45 5.968-13.526 13.286-13.526"
  }));
};
export default SvgSearch;